/*
 * Project: BookingEngine
 * Module: components/booking/rooms/RoomFilter.js
 * vim:ft=javascript.jsx:
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  DEVICES, setFilterCategory, setFilterOrder, setUserCurrency,
} from '../../../actions/Booking';

import DsDropdownList from '../../ds/molecules/DropdownList';
import Btn from '../../ds/atoms/btn';
import { IconComponent } from '../../ds/atoms/icons/iconComponent';

const getCategories = (rooms, context) => {
  const categories = {};
  rooms.forEach((room) => {
    if (room.category) {
      categories[room.category.name] = room.category;
    }
  });
  const values = Object.values(categories);
  const orderedValues = values
    .sort((a, b) => a.name.localeCompare(b.name)) // Sort by name
    .map((cat) => ({ ...cat, code: `cat_${cat.pk || cat.code}` }));
  orderedValues.unshift({ code: 'cat_all', name: context.t('All rooms') });
  return orderedValues;
};

const getOrders = (context) => ([
  {
    code: 'recommended', name: context.t('Recommended'), reverse: false,
  },
  {
    code: 'price_ASC', name: context.t('Price: Low to High'), reverse: false,
  },
  {
    code: 'price_DESC', name: context.t('Price: High to Low'), reverse: true,
  },
]);

const RoomFilter = (props, context) => {
  const [showFilters, setShowFilters] = useState(false);
  const {
    currencies, filterCurrency, filterCategory, lang, filterOrder,
    onChangeCategory, onSortChange, onChangeCurrency, rooms,
  } = props;
  const categories = getCategories(rooms, context);
  const orders = getOrders(context);
  const variant = 'dot';
  return (
          <div className={`RoomFilters${showFilters ? '' : ' closed'}`}>
            {props.isDesktop === true
            && <div className="border-b md:hidden text-gray-500 py-1 my-2 text-base">
              <Btn onClick={() => setShowFilters(!showFilters)}>
                {showFilters ? <IconComponent icon="cross"/> : <IconComponent icon="filter"/>}
              </Btn>
            </div>
            }
            {props.isDesktop === false
            && <hr style={{
              color: '#b4b4b4', paddingTop: '5px', paddingBottom: '5px', marginTop: '-10px',
            }}/>
            }
            <div className="md:flex -mx-2">
              <DsDropdownList label={context.t('View results by')}
                              variant={variant}
                              lang={lang}
                              items={categories}
                              initialId={filterCategory}
                              onChange={onChangeCategory}
                              className="mx-2 text-primary"/>
              <DsDropdownList label={context.t('Sort by')}
                              variant={variant}
                              lang={lang}
                              items={orders}
                              initialId={filterOrder}
                              onChange={onSortChange}
                              className="mx-2 text-primary"/>
              <DsDropdownList label={context.t('View rates in')}
                              variant={variant}
                              lang={lang}
                              items={currencies}
                              initialId={filterCurrency}
                              textKey="code"
                              onChange={onChangeCurrency}
                              className="mx-2 md:ml-auto text-primary"
              />
            </div>
          </div>
  );
};

RoomFilter.contextTypes = {
  rooms: PropTypes.array.isRequired,
};

RoomFilter.contextTypes = {
  router: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  lang: state.i18nState.lang,
  chain: state.bookingFormState.chain,
  isDesktop: state.booking.device === DEVICES.DESKTOP,
  distributions: state.bookingFormState.distributions,
  multipleRoomStep: state.booking.multipleRoomStep,
  filterCategory: state.booking.filterCategory,
  filterOrder: state.booking.filterOrder,
  currencies: state.booking.currencies,
  filterCurrency: state.booking.filterCurrency,
});

const mapDispatchToProps = (dispatch) => ({
  onSortChange: (payload) => dispatch(setFilterOrder(payload)),
  onChangeCurrency: (payload) => dispatch(setUserCurrency(payload)),
  onChangeCategory: (payload) => dispatch(setFilterCategory(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RoomFilter);
